import React from "react";

const FILL_COLOR = "#ffc711";

export default function Star({ fillType, onMouseEnter, index, onClick }) {
    const getFill = () => {
        let fill = FILL_COLOR;
        switch (fillType) {
            case "fill":
                fill = FILL_COLOR;
                break;
            case "none":
                fill = "none";
                break;
            case "half":
                fill = "url(#star-linear-gradient)";
                break;
            default:
                fill = "none";
                break;
        }
        return fill;
    };

    const handleMouseEnter = (event) => {
        onMouseEnter(index);
    };

    const handleStarClick = () => {
        onClick(index);
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 17.885 17"
            strokeWidth="5"
            stroke-color="#ffffff"
            onMouseEnter={handleMouseEnter}
            onClick={handleStarClick}
        >
            <linearGradient id="star-linear-gradient">
                <stop offset="0%" stopColor={FILL_COLOR} />
                <stop offset="50%" stopColor={FILL_COLOR} />
                <stop offset="50%" stopColor="transparent" />
                <stop offset="100%" stopColor="transparent" />
            </linearGradient>
            <path
                className="rate__star"
                d="M12.74,18.166,18.266,21.5,16.8,15.211l4.878-4.229-6.431-.552L12.74,4.5l-2.512,5.929L3.8,10.982l4.878,4.229L7.213,21.5Z"
                transform="translate(-3.797 -4.5)"
                strokeWidth="1"
                stroke={FILL_COLOR}
                fill={getFill()}
            />
        </svg>
    );
}
